// extracted by mini-css-extract-plugin
export default {"payment-method-select":"payment-method-selectnkqxg","paymentMethodSelect":"payment-method-selectnkqxg"};